import styled from "styled-components";

export const Content = styled.div`
  margin-bottom: 5em;
`;
export const Image = styled.img`
  position: absolute;
  right: 6vw;
  max-width: 300px;
  min-width: 250px;
  width: 50vw;
`;
export const MainContent = styled.div`
  margin-top: 18rem;
`;
export const Title = styled.h1`
  font-weight: normal;
  font-size: 2rem;
  margin-top: 5em;
`;
export const Description = styled.p`
  color: #999;
  max-width: 350px;
  line-height: 200%;
  margin-bottom: 2.5em;
`;

export const Container = styled.div`
  height: 700px;
  display: flex;
  justify-content: space-between;
  position: relative;
  padding: 0 3em 0 2em;
  margin-bottom: 5em;
`;

export const DecorationLeft = styled.div`
  height: 220px;
  width: 66.85px;
  background: url("img/talk-to-us-left-decoration.png");
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
`;

export const DecorationRight = styled.div`
  height: 364px;
  width: 74.92px;
  background: url("img/talk-to-us-right-decoration.png");
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  bottom: 0;
  right: 0;
`;
